var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { PlayStatus } from '../../../learnware/LearnwareEnums';
export class IntentStart {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get intent() {
        return this.parent;
    }
    get shouldStart() {
        if (this.intent.playStatus === PlayStatus.Pending) {
            return this.isStartConditionFulfilled;
        }
        return false;
    }
    get isStartConditionFulfilled() {
        // is any of multiple start condition ats fulfilled
        return !this.intent.intentSettings.playbackStartConditions
            .map(startConditionKey => this.isSingleStartConditionFulfilled(startConditionKey))
            .includes(false);
    }
    isSingleStartConditionFulfilled(startConditionKey) {
        const pieces = startConditionKey.split('_');
        if (pieces.length > 1) {
            return this.intent.mediaPlayer.playerInfo[pieces[0]](pieces[1]);
        }
        return this.intent.mediaPlayer.playerInfo[pieces[0]];
    }
}
__decorate([
    computed
], IntentStart.prototype, "shouldStart", null);
__decorate([
    computed
], IntentStart.prototype, "isStartConditionFulfilled", null);
